import jwtInterceptor from "@/shared/jwtInterceptor";

const apiUrl= process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH;

export class TicketApi
{

  static async getTicketDepartmentInfoForEdit(id)
  {
    const url = apiUrl + 'admin/TicketDepartment/getInfoForEdit/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

}